import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import { DebitNoteDataEntity, DebitNoteEntity } from "../entities/DebitNoteEntity";

/**
 * Save Debit Note As Draft Use Case
 * Saves a debit note as draft (creates or updates it with draft status)
 */
export class SaveDebitNoteAsDraftUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(
    debitNoteData: DebitNoteDataEntity,
    options?: {
      jobid?: string | null;
      folder_id?: string | null;
      company_id?: number | null;
      gst_rates?: any;
      gst_types?: any;
      is_tds_applied?: number;
      tds_tax_id?: string | null;
      tds_tax_amount?: number | null;
      tds_tax_percentage?: number | null;
      tds_tax_name?: string | null;
      tds_section?: string | null;
    }
  ): Promise<DebitNoteEntity> {
    return await this.repository.saveDebitNoteAsDraft(debitNoteData, options);
  }
}

